/**
 * Whether a widget's content column should span the full width because its title column is
 * empty.
 *
 * `DoughnutWidget`, `HourlyChartWidget` and `FloorOccupancyWidget` all put a title/text column
 * to the left of their content, and two of the three collapse the *right* column when there is
 * nothing in the left one. Legacy wrote the test inline in each:
 *
 * ```js
 * if (!title && (!hastTextBloc || !sourceTextBloc)) rightBlocClass = '…full width…';
 * ```
 *
 * where `hastTextBloc` [sic] was `options.textBloc?.text !== undefined`. The second clause is
 * true whenever the text is absent *or* empty, so the whole expression reduces to "no title and
 * no text" — which is what `szeged_2`, `szeged_3` and `szeged_4` hit, all three carrying
 * `"title": ""` and `"textBloc": { "text": "" }`.
 *
 * Note what collapsing does **not** do: the left column keeps rendering, empty, and keeps its
 * own width class. That is the legacy DOM and it is load-bearing at `lg`, where an empty
 * `lg:flex-1` column still claims its share of the row.
 *
 * It lives in `lib/` rather than beside `TitleColumn.tsx` for the same reason `lib/pin.ts` does
 * (SYM-495): a module that exports both a component and a plain function breaks Fast Refresh.
 */
export function collapsesTitleColumn(title: string | undefined, text: string | undefined): boolean {
  return !title && !text;
}
